<template>
    <BasePanel 
		headline="lang_LABEL_TRACKS"
		:alvqa="alvqa"
	>
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                :loading="isLoading"
                item-key="id"
                :show-select="false"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                class="baseInlineEditingDataTable" 
                :items-per-page="600"
            >
                <template v-slot:top>
                    <v-row class="pt-3 pb-3">
                        <v-col cols="2">
                            <v-select
                                v-model="selectedDisc"
                                :items="selectedDiscItems"
                                :label="$t('lang_LABEL_TRACKS_CAPTION_SELECTED_DISC')"
                                menu-props="offset-y, offset-overflow"
                                outlined
                                hide-details
                                :alvqa="alvqa + '-dropdown-selected-disc'"
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2" align-self="center">
                            <BaseButton
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_CONTRACT_LABEL_CAPTION_ADD_TRACK"
                                block
                                :alvqa="alvqa + '-button-add-track'"
                            />
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:body="props">
                    <draggable
                        v-if="props.items.length !== 0"
                        :list="props.items"
                        tag="tbody"
                        @change="onPositionChange($event)"
                    >
                        <tr
                            v-for="(item, i) in props.items"
                            :key="item.trackPosition"
                        >
                            <td class="text-right">
                                <BaseIcon 
                                    icon="fa-arrows-alt"
                                    tooltipText="Drag&Drop"
                                    :alvqa="alvqa + '-icon-drag-drop'"
                                    :small="true"
                                />
                            </td>
                            <!-- <td>
                                <div :alvqa="alvqa + '-list-row-' + i + '-text-sound-carrier-number'">{{ item.soundCarrierNumber }}</div>
                            </td> -->
                            <td>
                                <div :alvqa="alvqa + '-list-row-' + i + '-text-track-position'">{{ item.trackPosition }}</div>
                            </td>
                            <td class="ellipsis">
                                <BaseTooltip
                                    :simpleText="item.title"
                                    :alvqa="alvqa + '-list-row-' + i + '-text-title'"
                                />
                            </td>
                            <td>
                                <div :alvqa="alvqa + '-list-row-' + i + '-text-isrc'">{{ item.isrc }}</div>
                            </td>
                            <td>
                                <div :alvqa="alvqa + '-list-row-' + i + '-text-duration'">{{ $alvPlugin.transformSecondsToDuration(item.duration) }}</div>
                            </td>
                            <td class="ellipsis">
                                <BaseTooltip
                                    :simpleText="$alvPlugin.getArtistOrPerformerName(item.artist)"
                                    :alvqa="alvqa + '-list-row-' + i + '-text-performer'"
                                />
                            </td>
                            <td>
                                <div :alvqa="alvqa + '-list-row-' + i + '-text-gema-name'">{{ item.label.gemaName }}</div>
                            </td>
                            <td class="pl-0 text-right">
                                <BaseIcon 
                                    @click="deleteRow(item)"
                                    icon="delete"
                                    color="iconDelete"
                                    tooltipText="lang_GENERIC_CAPTION_DELETE"
                                    :alvqa="alvqa + '-icon-delete'"
                                />
                            </td>
                        </tr> 
                    </draggable>
                    <tbody v-else>
                        <tr class="v-data-table__empty-wrapper">                
                            <td :colspan="headers.length">
                                <div :alvqa="alvqa + '-list-no-data-text'">{{ noDataText }}</div>
                            </td>
                        </tr>        
                    </tbody> 
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel"
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from "@/components/_buttons/BaseButton"
import draggable from 'vuedraggable'

export default {
    name: "ReleasesTracksEditPanel",
    components: {
        BasePanel,
        BaseIcon,
        BaseTooltip,
        BaseButton,
        draggable
    },
    data() {
        return {
            alvqa: 'label-releases-edit-form-panel-tracks'
        }
    },
    computed: {
        headers() {
			return [
				// { 
                //     text: this.$t("lang_LABEL_RELEASES_TRACKS_CAPTION_DISC"), 
                //     align: "left", 
                //     width: "80px",
				// 	value: "soundCarrierNumber",
				// 	sortable: false
                // },
                { 
                    text: "", 
                    align: "center", 
                    width: "70px",
					value: "dragIcon",
					sortable: false
                },
                { 
                    text: "Pos", 
                    align: "left",
                    width: "80px", 
                    value: "trackPosition",
					sortable: false
                },
                { 
                    text: this.$t("lang_CAPTION_TITLE"), 
                    align: "left", 
                    value: "title",
                    sortable: false
                },
				{
					text: this.$t("lang_LABEL_TRACKS_CAPTION_ISRC"),
					align: "left",
					width: '150px',
                    sortable: false,
                    value: "isrc"
				},
				{
					text: this.$t("lang_LABEL_TRACKS_CAPTION_DURATION"),
					align: "left",
					width: '130px',
                    sortable: false,
					value: "duration"
				},
				{
					text: this.$t("lang_LABEL_TRACKS_CAPTION_ARTIST"),
					align: "left",
                    value: "artist",
                    sortable: false
				},
				{
					text: this.$t("lang_LABEL_RELEASE_LABEL"),
					align: "left",
					value: "label",
                    sortable: false
				},
				{ 
					text: "", 
					align: "right", 
					width: "70px", 
                    sortable: false,
					value: "delete" 
				},
			]
		},
        listItems() { 
            let items = []
            if(this.$store.getters.getLabelReleaseTracks !== null) {
                let discItems = this.$store.getters.getLabelReleaseTracks[this.selectedDisc]
                if(discItems === undefined || discItems === null) items = []
                else items = discItems
            }
            
            return items
        },
        isLoading() { return this.$store.getters.getIsLoading },
        noDataText() { return this.$t(this.$store.getters.getNoDataText) },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },

        // Disc Selector
        selectedDisc: {
            get() { return this.$store.getters.getLabelReleasesTracksSelectedDisc },
            set(selected) { this.$store.commit('setLabelReleasesTracksSelectedDisc', selected) }
        },
        selectedDiscItems() {
            let items = []
            let selectedNumberOfDiscs = this.$store.getters.getLabelReleasesDetailsSelectedNumberOfDiscs // get the selected number of discs from main form
            for (let index = 1; index <= selectedNumberOfDiscs; index++) {
                items.push({
                    text: "Disc " + index,
                    value: index
                })
            }

            return items
        }
    },
    methods: {
        deleteRow(row) {
            // set the selected track/row that should be deleted from the delete action
            this.$store.commit('setSelectedLabelReleaseTrack', row.alvId)
            this.$store.commit('setDeletionDialogContext', 'SelectedLabelReleaseTrack')
            this.$store.commit('setShowDeletionDialog', true)
        },
        addNewRow() {
            this.$store.commit("setShowSearchDialog", true)
        },

        onPositionChange(event) {
            let tracksOnRelease = this.$store.getters.getLabelReleaseTracks[this.selectedDisc]

            // change the Trackposition of the moved row
            let index = tracksOnRelease.findIndex(track => track.alvId === event.moved.element.alvId)
            tracksOnRelease[index].trackPosition = event.moved.newIndex+1 

            // If the row is dragged to a HIGHER track position (e.g. from 3 to 6) only the track position 3 - 5 will be reduced by 1 (the moved row is changed above line 239)
            if(event.moved.newIndex > event.moved.oldIndex) {
                let i = event.moved.oldIndex
                for (i; i <= event.moved.newIndex ; i++) {
                    if(i !== index) { // reduce the trackposition of all affected tracks, except the one we moved (see line 239)
                        tracksOnRelease[i]["trackPosition"]--
                    }
                }
            }

            // same logic as above but now the row is moved to a LOWER track position
            if(event.moved.newIndex < event.moved.oldIndex) {
                let i = event.moved.newIndex
                for (i; i <= event.moved.oldIndex ; i++) {
                    if(i !== index) {
                        tracksOnRelease[i]["trackPosition"]++
                    }
                }
            }

            tracksOnRelease.sort((a,b) => (a.trackPosition > b.trackPosition) ? 1 : (b.trackPosition > a.trackPosition) ? -1 : 0)
            this.$store.commit('setSpecificLabelReleaseTracks', tracksOnRelease)

            this.$store.commit('setSnackbar', { 
                type: 'success', 
                msg: this.$t('lang_LABEL_RELEASES_SNACKBAR_POSITION_CHANGED') + '<br />' + this.$t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        },
    }
}
</script>

<style>
  .baseInlineEditingDataTable table {
    table-layout: fixed;
    min-width: 0px !important;
  }
  .baseInlineEditingDataTable table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>